"use client";

import NextImage from "next/image";

import Tag from "./Tag";
import DescParagraph from "./DescParagraph";
import Title from "./Title";
import type { ContentStatus } from "@prisma/client";
import { getImageUrl } from "@/libs/CloudFlare";
import { displayDateTime } from "@/utils/displayDate";
import Link from "next/link";
import { Image } from "@nextui-org/react";

interface IProps {
  text?: "black" | "white";
  id: string;
  type: {
    type?: string;
    id?: number;
    name?: string;
  };
  createAt?: Date;
  updateAt?: Date;
  contentByLangs: {
    id: string;
    title: string | null;
    desc: string | null;
    bannerImg: string | null;
    createAt: Date;
    updateAt: Date;
    status: ContentStatus;
    language: {
      id: string;
      name: string;
    };
    tags: {
      Tag: {
        name: string | null;
        id: string | null;
      };
    }[];
    authors: {
      user: { id: string; firstName: string | null; lastName: string | null };
    }[];
  }[];
}

function HighlightPost(props: IProps) {
  console.log("props.updateAt", props.updateAt)
  console.log("props.createAt", props.createAt)
  return (
    <div className=" w-full grid grid-cols-3 grid-rows-1 gap-x-[32px] gap-y-[32px]">
      <div className="col-span-3 lg:col-span-2">
        <Link
          href={"/news/" + props.contentByLangs[0]?.id}
          className=" flex-col items-start space-y-[40px] !no-underline !text-black"
        >fsd
          <Image
            as={NextImage}
            src={getImageUrl(props.contentByLangs[0]?.bannerImg ?? "")}
            alt={props.contentByLangs[0]?.title ?? ""}
            width={1119}
            height={414}
            classNames={{
              wrapper: "rounded-[28px] bg-[#D9D9D9]",
            }}
            className=" w-full aspect-[16/9] object-cover !rounded-[28px] "
          />
        </Link>
      </div>
      <div className="col-span-3 xl:col-span-1 flex flex-col justify-between">
        <div className="flex flex-row items-center justify-start space-x-[22px]">
          {props.contentByLangs[0]?.tags.map((tag) => (
            <Tag title={tag.Tag.name ?? ""} href="#" />
          ))}
        </div>
        <Link
          href={"/news/" + props.contentByLangs[0]?.id}
          className=" flex-col items-start space-y-[40px] !no-underline"
        >
          <div className=" space-y-[20px] mt-[20px] xl:mt-0">
            <Title heading="h3">{props.contentByLangs[0]?.title ?? ""}</Title>
            <DescParagraph>{props.contentByLangs[0]?.desc ?? ""}</DescParagraph>
          </div>

          <DescParagraph>
            {props.contentByLangs[0] && displayDateTime(props.contentByLangs[0]?.updateAt, "DD MMM YYYY")} /{" "}
            {props.contentByLangs[0]?.language.name ?? ""}
          </DescParagraph>
        </Link>
      </div>
    </div>
  );
}

export default HighlightPost;
